import * as React from "react";
import {DmvVehicleData} from "./VinLookupOptions";
import * as urls from "../../../shared/urls";
import store from "../../../../store/Store";
import rootReducer from "../../../../store/Reducers";
import { LicensePlateLookupUtils } from "../../LicensePlateLookup/lib/Utils/LicensePlateLookupUtils";


interface IVinProps {
    component: any;
    form: any;
    value: string;
    onChange: () => void;
    isValid: boolean;
}

interface IVinState {
    value: string;
    isValid: boolean;
    shouldFocus: boolean;
    hasUserEdited: boolean;
}

const vinVehicleLookupRequest = {
    VIN: "",
    VehicleDataRequest: true,
    RegistrationDataRequest: true,
    VehicleIDRequest: true,
    PlateNumber: ""
};

const reduxStore = store({}, rootReducer);
const { LICENSE_PLATE_VALIDATION_URL } = urls;


export default class VinLookupComponentReact extends React.Component<IVinProps, IVinState , DmvVehicleData> {
    private textInputRef!: HTMLInputElement;
    state: IVinState = {
        value: this.props.value,
        isValid: this.props.isValid,
        shouldFocus: false,
        hasUserEdited: false
    };
    
    componentDidUpdate(prevProps: IVinProps, prevState: IVinState) {
        if (this.state.shouldFocus) {
            this.textInputRef.focus();
            this.setState({ shouldFocus: false });
        }

        if (prevProps.value !== this.props.value && this.props.value !== this.state.value) {
            this.setState({ value: this.props.value, hasUserEdited: false });
        }

        if (prevState.value != this.state.value) {
            this.props.onChange();
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
      return !(this.state.shouldFocus == true && nextState.shouldFocus == false);
    }

    searchVin = async (e) => {
        vinVehicleLookupRequest.VIN = (e.target.value || '').trim();
        vinVehicleLookupRequest.PlateNumber = "";

        if (!vinVehicleLookupRequest.VIN) {
            return;
        }

        this.setState({ hasUserEdited: false });

        const backendUrl = reduxStore.getState().valueOf();
        const object = backendUrl.valueOf();
        const url = object["Application"];
        const baseUrl = url["backendURL"];

        const vinLookupInfo = LicensePlateLookupUtils.LicensePlateSearch(
            vinVehicleLookupRequest,
            baseUrl + LICENSE_PLATE_VALIDATION_URL
        );

        vinLookupInfo.then(data => {
            if (!data) {
                return;
            }

            LicensePlateLookupUtils.ProcessVinLookup(data, this.props.component, this.props.form);
        });
    };
        
    onChange = e => {
        this.setState({ value: e.target.value, hasUserEdited: true });
    };

    focus = () => {
      this.setState({ shouldFocus: true });
    };

    render() {
        const {component} = this.props;
        
        let className = component.customClass + (component.inputClass && component.inputClass.length ? component.inputClass : "form-control");
        className = this.state.isValid ? className : className + " is-invalid";

        return (
            <div>
                <input
                    type="text"
                    className={className}
                    placeholder={component.placeholder}
                    title={component.tooltip}
                    tabIndex={component.tabIndex}
                    onBlur={this.searchVin}
                    onChange={this.onChange}
                    value={this.state.value}
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        this.searchVin(e);
                      }
                    }}
                    ref={element => {
                      if (element) {
                        this.textInputRef = element;
                      }
                    }}
                />
            </div>
        );
    }
}
